<template>
  <template v-if="!readOnly">
    <TextInput
      :label="label"
      :model="model"
      placeholder="https://www.youtube.com/watch?v=6iFbuIpe68k&t=7s"
      :errorMsg="errorMsg"
      @input="prepareVideoId"
    />
  </template>
  <div>
    <label v-if="readOnly" class="form-label text-muted"> {{ label }}</label>
    <iframe
      class="iframe-container rounded-4"
      :class="customClasses"
      v-if="videoLink"
      width="100%"
      height="100%"
      :src="videoLink"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :style="style"
    ></iframe>
    <div
      v-else
      class="iframe-container rounded-4 border d-flex justify-content-center align-items-center"
    >
      <p class="text-paragraph text-muted">Nenhum vídeo</p>
    </div>
  </div>
</template>

<style>
.iframe-container {
  aspect-ratio: 16/9;
}
</style>
<script>
import YoutubeInputController from "./YoutubeInputController";
export default YoutubeInputController;
</script>
